import "./SequenceDrugContainer.css";
import { TextField } from "@mui/material";

const SequenceDrugContainer = ({
  drug,
  openAccordionId,
  toggleAccordion,
  handleInputChange,
  input,
  handleAddToOrder,
  isDisabled,
  sequenceDrugList,
}) => {
  return (
    <div key={drug.drugTypeId}>
      <div className="drug-row">
        <button
          type="button"
          className={
            openAccordionId === drug.drugTypeId
              ? "drug-type-btn dark-color"
              : "drug-type-btn"
          }
          style={{ cursor: "pointer" }}
          onClick={() => toggleAccordion(drug.drugTypeId)}
        >
          {drug.drugName}
        </button>

        <div className="range-text">
          <div className="range-label">Available Range</div>
          <div className="range-values">
            {drug.sequenceRangeLow} - {drug.sequenceRangeHigh}
          </div>
        </div>

        <div className="range-input">
          <label>From</label>
          <TextField
            variant="outlined"
            size="small"
            sx={{
              height: "40px",
            }}
            inputMode="numeric"
            pattern="[0-9]*"
            type="text"
            value={input.from}
            onChange={(e) =>
              handleInputChange(
                drug.drugTypeId,
                "from",
                e.target.value,
                drug.sequenceRangeLow,
                drug.sequenceRangeHigh
              )
            }
          />
          <div
            className="error-container"
            style={{
              height: "15px",
              marginTop: "1px",
            }}
          >
            {input.from !== "" &&
            (Number(input.from) < Number(drug.sequenceRangeLow) ||
              Number(input.from) > Number(drug.sequenceRangeHigh))
              ? "Drug should be in range."
              : ""}
          </div>
        </div>

        <div className="range-input">
          <label>To</label>
          <TextField
            variant="outlined"
            size="small"
            inputMode="numeric"
            className="range-input-field"
            pattern="[0-9]*"
            type="text"
            sx={{ height: "40px" }}
            value={input.to}
            onChange={(e) =>
              handleInputChange(
                drug.drugTypeId,
                "to",
                e.target.value,
                drug.sequenceRangeLow,
                drug.sequenceRangeHigh
              )
            }
          />
          <div
            className="error-container"
            style={{
              height: "15px",
              marginTop: "1px",
            }}
          >
            {input.to !== "" &&
            (Number(input.to) > Number(drug.sequenceRangeHigh) ||
              Number(input.to) < Number(drug.sequenceRangeLow))
              ? "Drug should be in range."
              : ""}
          </div>
        </div>

        <div className="total-ordered">
          <div>Total Ordered</div>
          <div className="order-value">{input.ordered || 0}</div>
        </div>

        <button
          type="button"
          className="add-btn"
          disabled={isDisabled}
          onClick={() => handleAddToOrder(drug.drugTypeId, drug.drugName)}
        >
          Add to Order
        </button>
      </div>

      {/* Accordion placeholder div (only visible for selected row) */}
      {(() => {
        if (openAccordionId === drug.drugTypeId) {
          const item = sequenceDrugList?.find(
            (item) => item?.drugTypeId === openAccordionId
          );
          const label = `${item?.sequenceRangeLow} - ${item?.sequenceRangeHigh}`;
          const availableQuantity = item?.availableQuantity;

          return (
            <>
              <div
                className={`accordion-placeholder ${
                  openAccordionId === drug.drugTypeId ? "open" : ""
                }`}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <span className="accordion-heading">Range</span>
                  <span className="accordion-heading">Available</span>
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <span className="accordion-item">{label}</span>
                  <span className="accordion-item">{availableQuantity}</span>
                </div>
              </div>
            </>
          );
        }
        return null;
      })()}
    </div>
  );
};

export default SequenceDrugContainer;
